import { StyleSheet } from 'react-native';
import { Button, type ButtonProps } from 'react-native-paper';

const styles = StyleSheet.create({
  label: {
    fontSize: 18,
    fontWeight: '400',
    letterSpacing: 0,
    lineHeight: 24,
  },
});

type AppbarTextButtonProps = Omit<ButtonProps, 'mode' | 'labelStyle'>;

export const AppbarTextButton = ({ children, ...props }: AppbarTextButtonProps) => (
  <Button mode="text" labelStyle={styles.label} {...props}>
    {children}
  </Button>
);
